const initialState = {
    isMobile: false,
};

const general = (state = initialState, action) => {
    switch (action.type) {
        case 'IS_MOBILE':
            return {...state, isMobile: action.isMobile};
        default:
            return state;
    }
};

export default general;
